import React from "react";
import { useTheme } from "../../../context/themeContext";
import logoLight from "../../../assets/logos/Logo_Gold_black.png";
import logoDark from "../../../assets/logos/Logo_Gold.png";

/**
 * Logo oficial de Gold Loterías para las tarjetas de autenticación.
 * Igual que el Header: negro en tema claro, blanco en tema oscuro.
 * @param {object} props
 * @param {string} [props.className] contenedor
 * @param {string} [props.imgClassName] imagen
 */
const AuthLogo = ({ className = "", imgClassName = "" }) => {
  const { theme } = useTheme();
  const src = theme === "dark" ? logoDark : logoLight;

  return (
    <div className={className}>
      <img
        src={src}
        alt="Gold Loterías"
        width="160"
        height="66"
        decoding="async"
        className={imgClassName}
      />
    </div>
  );
};

export default AuthLogo;
